import { BREAKPOINTS, DEVICE_TYPE } from '../constants';

export const checkDeviceTypeBrowser = () => {
    const width = window.innerWidth;
    if (width < BREAKPOINTS.sm2) return DEVICE_TYPE.MOBILE;
    if (width < BREAKPOINTS.lg) return DEVICE_TYPE.TABLET;

    return DEVICE_TYPE.DESKTOP;
};

// Server-safe function (returns default value for SSR)
export const checkDeviceType = (deviceType: string) => {
    const config = {
        desktop: DEVICE_TYPE.DESKTOP,
        tablet: DEVICE_TYPE.TABLET,
        mobile: DEVICE_TYPE.MOBILE,
    };

    return config[deviceType as keyof typeof config] ?? DEVICE_TYPE.MOBILE;
};
